import stylex from '@stylexjs/stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { typography } from '@shared/tokens/typography.stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: fonts.din2014Regular,
    minHeight: '200px',
    padding: '0px',
  },
  xMarkIcon: {
    fill: colors.tertiaryIcon,
  },
  headerContainer: {
    maxHeight: '64px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingRight: '24px',
  },

  header: {
    padding: '16px 24px',
    color: colors.primaryText,
    fontSize: typography['fontSizeHeading-4'],
    fontFamily: fonts.din2014Regular,
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightBody-1'],
  },
  headerInvitationSetup: {
    padding: '16px 24px',
    color: colors.primaryText,
    fontSize: typography['fontSizeHeading-4'],
    fontFamily: fonts.din2014Regular,
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightBody-1'],
  },
  headerTicketSetup: {
    padding: '16px 24px',
    color: colors.primaryText,
    fontSize: typography['fontSizeHeading-4'],
    fontFamily: fonts.din2014Regular,
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightBody-1'],
  },
  headerSummary: {
    padding: '16px 32px',
    color: colors.primaryText,
    fontSize: typography['fontSizeHeading-4'],
    fontFamily: fonts.din2014Regular,
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightBody-1'],
  },
  headerSending: {
    padding: '16px 24px',
    color: colors.primaryText,
    fontSize: typography['fontSizeHeading-4'],
    fontFamily: fonts.din2014Regular,
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightBody-1'],
  },

  loader: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 24px',
    gap: '16px',
  },

  text: {
    fontSize: typography['fontSizeCaption-1'],
    color: colors.secondaryText,
  },

  btn: {
    display: 'flex',
    padding: '16px 24px',
    alignSelf: 'flex-end',
  },
  containerLoading: {
    minHeight: '172px',
  },
});
